/**
 * SALMAURA — Luxury Momentum Smooth Scroll Engine
 * Provides buttery-smooth, lightweight inertial scrolling for PC mouse wheels
 * while preserving native 1:1 touch, trackpad, and keyboard precision.
 */
(function() {
  'use strict';

  // Check if reduced motion is requested
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Only run on devices with a fine pointer (mouse / PC)
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!hasHover && isTouch) {
    return; // Leave mobile/pure touch devices 100% native
  }

  var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var targetY = currentY;
  var isRunning = false;
  var rafId = null;
  var lastWheelTime = 0;
  var ease = 0.125; // Luxury damping factor: fast responsive start, silk-smooth landing

  function getMaxScroll() {
    return Math.max(
      0,
      (document.documentElement.scrollHeight || document.body.scrollHeight || 0) - window.innerHeight
    );
  }

  function isScrollableElement(el, deltaY) {
    var current = el;
    while (current && current !== document.body && current !== document.documentElement) {
      if (current.scrollHeight > current.clientHeight) {
        var style = window.getComputedStyle(current);
        var overflowY = style.overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          var atTop = current.scrollTop <= 0;
          var atBottom = current.scrollTop + current.clientHeight >= current.scrollHeight - 1;
          if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) {
            return true;
          }
        }
      }
      current = current.parentElement;
    }
    return false;
  }

  function update() {
    var maxScroll = getMaxScroll();
    targetY = Math.max(0, Math.min(targetY, maxScroll));
    
    var diff = targetY - currentY;
    
    if (Math.abs(diff) < 0.5) {
      currentY = targetY;
      window.scrollTo(0, currentY);
      isRunning = false;
      rafId = null;
      return;
    }

    currentY += diff * ease;
    window.scrollTo(0, currentY);

    rafId = requestAnimationFrame(update);
  }

  function onWheel(e) {
    // Ignore pinch-zoom (ctrlKey) or horizontal swipes
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    // Check if scrolling inside a sub-container (e.g. cart drawer, menu, modal)
    if (isScrollableElement(e.target, e.deltaY)) {
      return;
    }

    var delta = e.deltaY;
    
    // Normalize delta across different browsers / delta modes
    if (e.deltaMode === 1) { // Lines mode (Firefox default)
      delta *= 32;
    } else if (e.deltaMode === 2) { // Pages mode
      delta *= window.innerHeight;
    }

    // Touchpad / Precision trackpad check:
    var isDiscreteMouseWheel = Math.abs(delta) >= 40 || Number.isInteger(delta);
    if (!isDiscreteMouseWheel && Math.abs(delta) < 25 && !Number.isInteger(delta)) {
      currentY = window.pageYOffset || document.documentElement.scrollTop;
      targetY = currentY;
      return;
    }

    // Prevent choppy native stepped scroll
    e.preventDefault();

    lastWheelTime = Date.now();
    var maxScroll = getMaxScroll();

    if (!isRunning) {
      currentY = window.pageYOffset || document.documentElement.scrollTop;
      targetY = currentY;
    }

    // Apply comfortable luxury multiplier (1.05x for natural, light travel)
    targetY += delta * 1.05;
    targetY = Math.max(0, Math.min(targetY, maxScroll));

    if (!isRunning) {
      isRunning = true;
      rafId = requestAnimationFrame(update);
    }
  }

  // Synchronize when the user interacts with native scrollbar or keyboard navigation
  function onNativeScroll() {
    var now = Date.now();
    var actualScrollY = window.pageYOffset || document.documentElement.scrollTop;
    
    if (!isRunning || (now - lastWheelTime > 150 && Math.abs(actualScrollY - currentY) > 20)) {
      currentY = actualScrollY;
      targetY = actualScrollY;
    }
  }

  // Smooth scroll helper for anchor links (#comprar, #faq, etc.)
  window.salmauraSmoothScrollTo = function(destinationY) {
    var maxScroll = getMaxScroll();
    targetY = Math.max(0, Math.min(destinationY, maxScroll));
    currentY = window.pageYOffset || document.documentElement.scrollTop;
    if (!isRunning) {
      isRunning = true;
      rafId = requestAnimationFrame(update);
    }
  };

  // Attach event listeners
  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onNativeScroll, { passive: true });

  window.addEventListener('resize', function() {
    var actualScrollY = window.pageYOffset || document.documentElement.scrollTop;
    currentY = actualScrollY;
    targetY = actualScrollY;
  }, { passive: true });

})();
